import { useLocation } from "react-router-dom";
import {
  getUnit,
  getAllProperties,
  getProperty,
  getFleet,
  getAllFleets,
  updateUnit,
  addUnit,
  createProperties,
  createBuildings,
  deleteBuilding,
  updateBuilding,
  deleteUnit
} from "../lib/api";
import { useEffect, useState, useCallback } from "react";
import LocationDetails from "../components/EditUnits/LocationDetails";
import SaveLocationDetails from "../components/EditUnits/SaveLocationDetails";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../components/Common/ConfirmModal";
import useFleetStore from "../utils/store";
import AddBuldingModel from "../components/EditUnits/AddBuldingModel";
import AddpPropertyModel from "../components/EditUnits/AddpPropertyModel";
import ToastMessage from "../components/Common/ToastMessage";
import CreatePodModal from "../components/PodModals/CreatePodModal";
import { unitListReturnPath } from "../utils/unitListReturn";

const toFloorValue = (floor) => {
  const trimmedFloor = typeof floor === "string" ? floor.trim() : floor;
  if (trimmedFloor === "" || trimmedFloor == null) {
    return null;
  }

  const floorNumber = Number(trimmedFloor);
  return Number.isFinite(floorNumber) ? floorNumber : null;
};

export const EditUnit = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const unid = queryParams.get("unid");
  const serialNumber = queryParams.get("serialNumber");
  const navigate = useNavigate();
  const returnPath = unitListReturnPath(location.state);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
  };

  const [activeLocationPage, setActiveLocationPage] = useState(true);
  const { setSelectedFleet } = useFleetStore();

  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);

  const [properties, setProperties] = useState([]);
  const [buildingList, setBuildingList] = useState([]);
  const [zoneList, setZoneList] = useState([]);

  const [selectedpropertie, setSelectedpropertie] = useState({});
  const [selectedBuilding, setSelectedBuilding] = useState({});

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAddBuildingModel, setShowAddBuildingModel] = useState(false);
  const [showAddPropertyModel, setShowAddPropertyModel] = useState(false);
  const [showPodModal, setShowPodModal] = useState(false);

  const [showDeleteBuildingModel, setShowDeleteBuildingModel] = useState(false);
  const [buildingToDelete, setBuildingToDelete] = useState(null);

  const [showUnitNameChangeModel, setShowUnitNameChangeModel] = useState(false);
  const [tempUnitName, setTempUnitName] = useState('');

  const [error, setError] = useState({});

  const [selectedZoneUnid, setSelectedZoneUnid] = useState(null);

  // api calls
  const getUnitApi = useCallback(async () => {
    const payload = { unid, serialNumber };
    try {
      const response = await getUnit(payload);
      const resUnit = response?.data?.data?.unit;
      setSelectedUnit(resUnit);
      setSelectedpropertie({
        unid: resUnit?.metadata?.propertyUnid,
        name: resUnit?.metadata?.propertyName,
      });
      setSelectedBuilding({
        unid: resUnit?.metadata?.buildingUnid,
        name: resUnit?.metadata?.buildingName,
      });
    } catch (error) {
      console.error("Error fetching unit data:", error);
    }
  }, [unid, serialNumber]);

  const getAllPropertiesApi = async () => {
    const payload = {
      pageNumber: 1,
      pageSize: 100,
    };

    try {
      const response = await getAllProperties(payload);
      setProperties(response?.data?.data?.properties);
    } catch (error) {
      console.error("Error fetching unit data:", error);
    }
  };

  const getPropertyApi = useCallback(async () => {
    if (!selectedpropertie?.unid) return;
    try {
      const response = await getProperty({ unid: selectedpropertie?.unid });
      setBuildingList(response?.data?.data?.property?.buildings);
    } catch (error) {
      console.error("Error fetching property data:", error);
    }
  }, [selectedpropertie?.unid]);

  const getZoneApi = useCallback(async () => {
    try {
      const response = await getFleet(unid);
      setSelectedZone(response?.data?.zone);
    } catch (error) {
      console.error("Error fetching unit data:", error);
    }
  }, [unid]);

  const getAllZonesApi = async () => {
    const payload = { pageNumber: 1, pageSize: 100 };

    try {
      const response = await getAllFleets(payload);
      setZoneList(response?.data?.zones);
    } catch (error) {
      console.error("Error fetching unit data:", error);
    }
  };

  const handleRemoveZone = () => {
    setSelectedZoneUnid(selectedZone.unid);
    setSelectedZone(null);
  };

  const updateFleetApi = async () => {
    if (selectedZone === null) {
      const payload = { unid: selectedZoneUnid, serialNumber: serialNumber }
      try {
        const response = await deleteUnit(payload);
        if (response.status === 200) {
          navigate(returnPath, {
            state: {
              toast: {
                message: "Unit removed from zone successfully",
                type: "success",
              },
            },
          });
        }
      } catch (error) {
        if (error.message === "Failed to fetch") {
          showToast('Network error. Please try again', 'failed');
        } else {
          showToast(error.message);
        }
      }
    } else {
      const payload = { unid: selectedZone.unid };
      const body = {
        name: selectedUnit?.metadata?.name,
        propertyUnid: selectedpropertie?.unid,
        serialNumber: serialNumber,
        buildingUnid: selectedBuilding?.unid,
        floor: toFloorValue(selectedUnit?.metadata?.floor),
        room: selectedUnit?.metadata?.room,
        unit: selectedUnit?.metadata?.unit,
      };

      try {
        const response = await addUnit(payload, body);
        if (response.status === 200) {
          showToast('Unit Edited Successfully', 'success');
          setSelectedFleet(selectedZone);
          navigate(returnPath, {
            state: {
              toast: {
                message: "Unit Edited Successfully",
                type: "success",
              },
            },
          });
        }
      } catch (error) {
        if (error.message === "Failed to fetch") {
          showToast('Network error. Please try again', 'failed');
        } else {
          showToast(error.message);
        }
      }
    };
  };

  const AddBuildingApi = async (buildingName) => {
    const postData = { name: buildingName.trim() };
    const payload = { unid: selectedpropertie?.unid };
    try {
      const response = await createBuildings(payload, postData);
      await getPropertyApi();
      setSelectedBuilding(response?.data?.data?.building);
      if (response.status === 200) {
        showToast('Building added successfully', 'success')
      }
    } catch (error) {
      console.error("Error fetching unit data:", error);
      showToast(error.message, 'failed')
    }
  };

  const deleteBuildingApi = async (buildingUnid) => {
    const payload = {
      unid: selectedpropertie?.unid,
      buildingUnid,
    };

    try {
      const response = await deleteBuilding(payload);
      await getPropertyApi();
      if (response.status === 200) {
        showToast('Building deleted successfully', 'success')
      }
      setSelectedBuilding({});
    } catch (error) {
      console.error("Error fetching unit data:", error);
      if (error?.errorCode === "FMS_BUILDING_REFERENCED_BY_UNITS") {
        showToast(error.message || "building cannot be deleted because it is referenced by units.", "failed");
      } else {
        showToast("Error: Unable to delete property", "failed");

      }
    }
  };

  const updateBuildingApi = async (unid, name) => {
    const payload = {
      unid: selectedpropertie?.unid,
      buildingUnid: unid,
    };
    const postdata = { name: name.trim() };

    try {
      const response = await updateBuilding(payload, postdata);
      await getPropertyApi();
      if (response.status === 200) {
        showToast('Building updated successfully', 'success')
      }
    } catch (error) {
      console.error("Error fetching unit data:", error);
      showToast(error.message, 'failed')
    }
  };

  const handleNextButtonAPI = async (e) => {
    e?.preventDefault?.();
    const payload = { unid: unid, serialNumber: serialNumber };

    const body = {
      name: selectedUnit?.metadata?.name,
      propertyUnid: selectedpropertie?.unid,
      buildingUnid: selectedBuilding?.unid,
      floor: toFloorValue(selectedUnit?.metadata?.floor),
      room: selectedUnit?.metadata?.room,
      unit: selectedUnit?.metadata?.unit,
    };

    try {
      const response = await updateUnit(payload, body);
      if (response.status === 200) {
        setActiveLocationPage(false);
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        showToast('Network error. Please try again', 'failed');
      } else {
        showToast(error.message);
      }
    }
  };

  const handleSavePropety = async (propertyName) => {
    try {
      const response = await createProperties({ name: propertyName.trim() });
      const resProperty = response?.data?.data?.property;

      if (response.status === 200) {
        showToast('Property added successfully', 'success');

        // Update selected property
        const newProperty = {
          unid: resProperty?.unid,
          name: resProperty?.name,
        };
        setSelectedpropertie(newProperty);

        // Prepare new unit name and set it temporarily
        const updatedName = `${resProperty?.name}-${serialNumber.slice(-4)}`;
        setTempUnitName(updatedName);

        // Update everything else BUT keep the old name
        setSelectedBuilding({});
        setSelectedUnit((prev) => ({
          ...prev,
          metadata: {
            ...prev?.metadata,
            name: prev?.metadata?.name,
          },
        }));

        setShowUnitNameChangeModel(true); // Show confirm modal
      }

      getAllPropertiesApi();
      setShowAddPropertyModel(false);
    } catch (error) {
      console.error("Error fetching unit data:", error);
      if (error.status === 409) {
        showToast(error.message, 'failed');
      }
    }
  };


  const handlePropertyChange = (item) => {
    setSelectedpropertie(item);

    const updatedName = `${item?.name}-${serialNumber.slice(-4)}`;
    setTempUnitName(updatedName); // Store temporarily
    setSelectedBuilding({});
    setSelectedUnit((prev) => ({
      ...prev,
      metadata: {
        ...prev?.metadata,
        name: prev?.metadata?.name,
      },
    }));

    setShowUnitNameChangeModel(true); // Show confirmation modal
  };


  const handleChangeUnit = (e) => {
    e.preventDefault();

    // Only update the name
    setSelectedUnit((prev) => ({
      ...prev,
      metadata: {
        ...prev?.metadata,
        name: tempUnitName,
      },
    }));

    setShowUnitNameChangeModel(false);
    setTempUnitName('');
  };

  const handleCancelChangeUnit = (e) => {
    e.preventDefault();
    setShowUnitNameChangeModel(false);
    setTempUnitName('');
  };


  const handleGoBack = (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const handleCancelDelete = (e) => {
    e.preventDefault();
    setShowConfirmModal(false);
  };

  const handleCancelDeleteBuilding = () => {
    setBuildingToDelete(null);
    setShowDeleteBuildingModel(false);
  }


  const handleConfirmBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let errorMsg = '';

    if (name === "floor") {
      const numericValue = value.replace(/\D/g, '');

      if (numericValue.length > 15) {
        errorMsg = 'Floor number cannot exceed 15 digits.';
        setError((prev) => ({
          ...prev,
          [name]: errorMsg,
        }));
        return;
      }
      setSelectedUnit((prev) => ({
        ...prev,
        metadata: {
          ...prev?.metadata,
          [name]: numericValue ? Number(numericValue) : null,
        }
      }));
    } else if (name === 'room') {
      if (value.length > 15) {
        errorMsg = 'Room number cannot exceed 15 characters.';
        setError((prev) => ({
          ...prev,
          [name]: errorMsg,
        }));
        return; // ⛔ Prevent state update
      }

      setError((prev) => ({
        ...prev,
        [name]: '',
      }));

      setSelectedUnit((prev) => ({
        ...prev,
        metadata: {
          ...prev?.metadata,
          [name]: value,
        }
      }));

    } else if (name === 'unit') {
      if (value.length > 15) {
          errorMsg = 'Apartment name cannot exceed 15 characters.';
          setError((prev) => ({
              ...prev,
              [name]: errorMsg,
          }));
          return;
      }

      setError((prev) => ({
          ...prev,
          [name]: '',
      }));

      setSelectedUnit((prev) => ({
        ...prev,
        metadata: {
          ...prev?.metadata,
          [name]: value,
        }
      }));

    }

    setSelectedUnit((prev) => ({
      ...prev,
      metadata: {
        ...prev?.metadata,
        [name]: value,
      },
    }));
  };

  const handleUnitNameChange = (e) => {
    const value = e.target.value;

    setSelectedUnit((prev) => ({
      ...prev,
      metadata: {
        ...prev?.metadata,
        name: value,
      },
    }));
  };


  function handleDeleteBuilding() {
    if (buildingToDelete) {
      deleteBuildingApi(buildingToDelete);
    } else {
      showToast("No building selected to delete", "failed");
    }
    setShowDeleteBuildingModel(false);
    setBuildingToDelete(null);
  }

  const validateFields = useCallback(() => {
    const newErrors = {};

    if (!selectedUnit?.metadata?.name?.trim()) {
      newErrors.unitName = "Unit name is required";
    }

    setError(newErrors);

    return Object.keys(newErrors).length === 0;
  }, [selectedUnit]);

  useEffect(() => {
    validateFields()
  }, [selectedUnit, selectedBuilding, validateFields])

  const handleCreateZone = (e) => {
    e.preventDefault()
    setShowPodModal(true);
  }

  useEffect(() => {
    getUnitApi();
    getAllPropertiesApi();
    getZoneApi();
    getAllZonesApi();
  }, [getUnitApi, getZoneApi]);

  useEffect(() => {
    getPropertyApi();
  }, [getPropertyApi]);


  return (
    <>
      {activeLocationPage && (
        <LocationDetails
          selectedUnit={selectedUnit}
          properties={properties}
          buildingList={buildingList}
          selectedpropertie={selectedpropertie}
          serialNumber={serialNumber}
          selectedBuilding={selectedBuilding}
          setSelectedBuilding={setSelectedBuilding}
          handlePropertyChange={handlePropertyChange}
          unid={unid}
          handleChange={handleChange}
          setActiveLocationPage={setActiveLocationPage}
          handleGoBack={handleGoBack}
          handleNextButtonAPI={handleNextButtonAPI}
          setShowAddBuildingModel={setShowAddBuildingModel}
          setShowAddPropertyModel={setShowAddPropertyModel}
          handleUnitNameChange={handleUnitNameChange}
          error={error}
          validateFields={validateFields}
        />
      )}

      {activeLocationPage === false && (
        <SaveLocationDetails
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          selectedUnit={selectedUnit}
          serialNumber={serialNumber}
          zoneList={zoneList}
          unid={unid}
          selectedpropertie={selectedpropertie}
          selectedBuilding={selectedBuilding}
          updateFleetApi={updateFleetApi}
          setActiveLocationPage={setActiveLocationPage}
          handleGoBack={handleGoBack}
          handleUnitNameChange={handleUnitNameChange}
          handleCreateZone={(e) => handleCreateZone(e)}
          handleRemoveZone={handleRemoveZone}
        />
      )}

      {showAddPropertyModel && (
        <AddpPropertyModel
          setShowAddPropertyModel={setShowAddPropertyModel}
          onSubmit={handleSavePropety}
        />
      )}

      {showAddBuildingModel && (
        <AddBuldingModel
          setShowAddBuildingModel={setShowAddBuildingModel}
          buildingList={buildingList}
          selectedpropertie={selectedpropertie}
          AddBuildingApi={AddBuildingApi}
          deleteBuildingApi={deleteBuildingApi}
          updateBuildingApi={updateBuildingApi}
          setShowDeleteBuildingModel={setShowDeleteBuildingModel}
          setBuildingToDelete={setBuildingToDelete}

        />
      )}

      {showDeleteBuildingModel && (
        <ConfirmModal
          title="Remove Building"
          subText="Your Building will be deleted from this property"
          confirmMessage="Are you sure you want to delete the building from property?"
          cancelText="Cancel"
          submitText="Confirm"
          onCancel={handleCancelDeleteBuilding}
          onSubmit={handleDeleteBuilding}
        />
      )}

      {showUnitNameChangeModel && (
        <ConfirmModal
          title="Change Unit Name?"
          confirmMessage="This action will change the previous unit name."
          cancelText="Cancel"
          submitText="Confirm"
          onCancel={handleCancelChangeUnit}
          onSubmit={handleChangeUnit}
        />
      )}

      {showConfirmModal && (
        <ConfirmModal
          title="Cancel Edit Unit?"
          confirmMessage="You have unsaved changes.Do you want to cancel and discard your edits?"
          cancelText="Cancel"
          submitText="Confirm"
          onCancel={handleCancelDelete}
          onSubmit={handleConfirmBack}
        />
      )}

      {showPodModal && (
        <CreatePodModal showPodModal={showPodModal} setShowPodModal={setShowPodModal} getAllZonesApi={getAllZonesApi} onCreateSuccess={(newZone) => {
          setZoneList(prev => [...prev, newZone]);
          setSelectedZone(newZone);
          setShowPodModal(false);
          showToast("Zone created successfully", "success");
        }} />
      )}

      <ToastMessage
        message={toast.message}
        type={toast.type}
        show={toast.show}
        onClose={() => setToast((prev) => ({ ...prev, show: false }))}
      />
    </>
  );
};
